import React, { useState } from 'react'
// import material ui
import { makeStyles } from '@material-ui/core';
// import fetch
import axInst from '../../../_helpers/axios-instance';
import axInstTest from '../../../_helpers/axios-instance-test';
// import i18n
import { useTranslation } from 'react-i18next';
// import redux
import { connect } from 'react-redux';

const useStyles = makeStyles(theme => ({
    container: {
        maxWidth: 1246,
        margin: "0 auto",
        padding: "0 15px"
    },

    body: {
        padding: "30px 0",
        [theme.breakpoints.down(768)]: {
            padding: "15px 0"
        },
    },

    card: {
        maxWidth: 808,
        width: "100%",
        margin: "0 auto",
        padding: "36px 64px 56px 64px",
        boxSizing: "border-box",
        [theme.breakpoints.down(768)]: {
            padding: "36px",
        },
        [theme.breakpoints.down(479)]: {
            padding: "20px",
        },
    },

    card__title: {
        display: "flex",
        alignItems: "center",
        gap: 5,
        fontSize: 16,
        fontWeight: 700,
        color: "#2F80ED",
        paddingBottom: 32,
    },

    form: {
        display: "grid",
        gap: 16,
    },

    btn: {
        width: 164,
        margin: "16px auto 0 auto",
        fontWeight: 700,
    },
}));

const IntegrationRequest = (props) => {
    const { userSelectedData, slug, setSnack } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const [disabled, setDisabled] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        setDisabled(true);
        axInst.post(`/api/post-integrations-requests/`, {
            customer_id: userSelectedData?.customer_id,
            type_integration: slug,
        }).then(response => {
            window.history.back();
            setSnack({
                active: true,
                variant: "success",
                text: t("common:created_integration_label"),
            });
        }).catch(err => {
            if (err?.response?.data?.error === "Integration request already exists for this customer user") {
                setSnack({
                    active: true,
                    variant: "success",
                    text: t("common:already_request_label"),
                });
            } else {
                setSnack({
                    active: true,
                    variant: "error",
                    text: err?.message || t("common:unknown_error_label"),
                });
            }
        }).finally(() => {
            setDisabled(false);
        });
    };

    return (
        <div className={`dashboard-card ${classes.card}`}>
            <h2 className={classes.card__title}><svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2595_1187)">
                    <path d="M22.4499 11.98L22.677 12.4363L23.1848 12.3932L25.4686 12.1992C25.4691 12.1992 25.4697 12.1992 25.4703 12.1991C25.6282 12.1869 25.7866 12.2173 25.9287 12.2872C26.0709 12.3572 26.1918 12.4641 26.2785 12.5967C26.2788 12.5971 26.2791 12.5975 26.2793 12.598L27.911 15.1287C27.9111 15.1288 27.9112 15.129 27.9113 15.1291C28.0053 15.2755 28.0532 15.4467 28.0488 15.6206C28.0444 15.7947 27.9877 15.9635 27.8862 16.105L27.8853 16.1062L26.6828 17.7897L26.3622 18.2387L26.6952 18.6785L27.9748 20.3681L27.9752 20.3687C28.1879 20.6489 28.2099 21.0325 28.0276 21.3373L28.0273 21.3379L26.4879 23.9179C26.4876 23.9185 26.4872 23.9191 26.4869 23.9196C26.404 24.056 26.2858 24.1674 26.1448 24.242L26.4955 24.9049L26.1448 24.242C26.0038 24.3166 25.8453 24.3516 25.6861 24.3435C25.6853 24.3434 25.6846 24.3434 25.6838 24.3433L23.2689 24.1957L22.769 24.1651L22.5492 24.6151L21.0623 27.6597C21.062 27.6604 21.0617 27.6611 21.0613 27.6617C20.9884 27.8075 20.8765 27.9303 20.7381 28.0165C20.5995 28.1028 20.4398 28.1491 20.2766 28.1502H16.9452C16.7825 28.1487 16.6233 28.1023 16.4852 28.0161L16.088 28.6523L16.4852 28.0161C16.3471 27.9299 16.2355 27.8073 16.1627 27.6617C16.1623 27.6611 16.162 27.6604 16.1617 27.6597L14.7641 24.8L14.5373 24.3358L14.0227 24.3823L11.4375 24.6162C11.4369 24.6163 11.4362 24.6163 11.4355 24.6164C11.2746 24.6295 11.1132 24.5984 10.9688 24.5263C10.8243 24.4542 10.7023 24.3439 10.616 24.2073C10.6157 24.2068 10.6154 24.2063 10.6151 24.2058L8.98021 21.5734C8.88701 21.4232 8.84183 21.2482 8.8507 21.0717C8.85957 20.8951 8.92207 20.7255 9.02985 20.5855L9.03027 20.5849L10.5103 18.6578L10.8491 18.2166L10.5252 17.7643L9.33543 16.103C9.33533 16.1028 9.33523 16.1027 9.33513 16.1025C9.23405 15.9609 9.17781 15.7923 9.17368 15.6184C9.16955 15.4443 9.21783 15.273 9.31226 15.1266L9.31245 15.1263L10.9454 12.5937C11.032 12.4613 11.1526 12.3546 11.2945 12.2847C11.4361 12.2149 11.5938 12.1843 11.7512 12.1961L14.2054 12.4055L14.6987 12.4476L14.9313 12.0104L16.3699 9.3057C16.4464 9.16485 16.5598 9.04744 16.698 8.96607C16.8364 8.88458 16.9943 8.84231 17.1549 8.84379C17.1553 8.84379 17.1558 8.8438 17.1563 8.8438L20.3876 8.89305C20.5474 8.89694 20.7032 8.94411 20.8384 9.02955C20.9739 9.11519 21.0836 9.23604 21.1557 9.37918C21.1558 9.37949 21.156 9.37981 21.1562 9.38012L22.4499 11.98ZM17.5645 9.6626L17.1059 9.6555L16.8906 10.0605L15.4373 12.7948C15.437 12.7953 15.4367 12.7958 15.4364 12.7963C15.3551 12.9465 15.2321 13.0699 15.0822 13.1517C14.9323 13.2334 14.7621 13.27 14.592 13.2571L12.0974 13.0446L11.6479 13.0063L11.4034 13.3854L10.2502 15.1737L9.97383 15.6023L10.2708 16.0169L11.4857 17.7128L11.4857 17.7128C11.5941 17.8642 11.6511 18.0464 11.6481 18.2326C11.6451 18.4186 11.5825 18.5988 11.4695 18.7465C11.4694 18.7467 11.4693 18.7469 11.4691 18.747L9.96554 20.7005L9.64875 21.112L9.92257 21.5533L11.0819 23.4218L11.3261 23.8154L11.7873 23.7733L14.4266 23.5328L14.4277 23.5327C14.6032 23.5165 14.7795 23.554 14.9332 23.6403C15.0868 23.7265 15.2105 23.8573 15.288 24.0155C15.2881 24.0156 15.2881 24.0158 15.2882 24.0159L16.703 26.9165L16.9085 27.3377H17.3771H19.8438H20.3117L20.5174 26.9174L22.0198 23.8479C22.0201 23.8472 22.0205 23.8466 22.0208 23.846C22.0977 23.6924 22.2178 23.5645 22.3663 23.478C22.5148 23.3915 22.6853 23.3501 22.857 23.359C22.8576 23.359 22.8583 23.3591 22.859 23.3591L25.3148 23.5068L25.7702 23.5342L26.004 23.1424L27.0893 21.3233L27.3482 20.8892L27.0431 20.4863L25.7363 18.7603C25.7362 18.7601 25.7361 18.76 25.736 18.7599C25.6246 18.6122 25.5632 18.4328 25.5609 18.2478C25.5585 18.0628 25.6153 17.8818 25.7229 17.7313C25.723 17.7312 25.723 17.7311 25.7231 17.731L26.9528 16.0175L27.2504 15.6027L26.9738 15.1737L25.8206 13.3854L25.5764 13.0067L25.1274 13.0445L22.784 13.2418L22.7833 13.2419C22.6094 13.2567 22.4352 13.2189 22.2832 13.1333C22.1312 13.0477 22.0085 12.9183 21.9311 12.762L21.9305 12.7609L20.6139 10.1154L20.4105 9.70667L19.9541 9.6996L17.5645 9.6626Z" fill="#2F80ED" stroke="#2F80ED" strokeWidth="1.5" />
                    <path d="M31.7001 22.8168C30.7647 25.7041 28.9084 28.2052 26.4157 29.9366C23.9229 31.6681 20.9311 32.5344 17.8989 32.4028C14.8667 32.2713 11.9612 31.1491 9.62775 29.2082C7.29431 27.2674 5.66162 24.615 4.97989 21.6574L7.60381 21.1394L2.60881 15.9718L-0.00585938 22.6533L2.75989 22.1107C3.53176 25.5825 5.42555 28.7035 8.1486 30.9913C10.8717 33.2792 14.2724 34.6066 17.8253 34.7683C21.3782 34.9301 24.8855 33.9173 27.8052 31.8863C30.7249 29.8554 32.8945 26.9194 33.9786 23.5321L31.7001 22.8168ZM34.2777 14.9851C33.5055 11.5134 31.6114 8.39268 28.8881 6.10514C26.1648 3.81761 22.764 2.4906 19.2111 2.32919C15.6582 2.16777 12.1511 3.18093 9.23161 5.21211C6.31214 7.24328 4.14285 10.1794 3.05897 13.5668L5.25739 14.2821C6.19243 11.3947 8.04843 8.89347 10.541 7.16179C13.0335 5.4301 16.0251 4.56347 19.0574 4.69468C22.0896 4.82589 24.9951 5.94771 27.3288 7.88824C29.6624 9.82876 31.2954 12.4809 31.9776 15.4383L29.3536 15.9594L34.3486 21.1148L36.9941 14.4424L34.2777 14.9851Z" fill="#2F80ED" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5 17.3438C18.1933 17.3438 17.8992 17.4656 17.6824 17.6824C17.4656 17.8992 17.3438 18.1933 17.3438 18.5C17.3438 18.8067 17.4656 19.1008 17.6824 19.3176C17.8992 19.5344 18.1933 19.6562 18.5 19.6562C18.8067 19.6562 19.1008 19.5344 19.3176 19.3176C19.5344 19.1008 19.6562 18.8067 19.6562 18.5C19.6562 18.1933 19.5344 17.8992 19.3176 17.6824C19.1008 17.4656 18.8067 17.3438 18.5 17.3438ZM15.0312 18.5C15.0312 17.58 15.3967 16.6977 16.0472 16.0472C16.6977 15.3967 17.58 15.0312 18.5 15.0312C19.42 15.0312 20.3023 15.3967 20.9528 16.0472C21.6033 16.6977 21.9688 17.58 21.9688 18.5C21.9688 19.42 21.6033 20.3023 20.9528 20.9528C20.3023 21.6033 19.42 21.9688 18.5 21.9688C17.58 21.9688 16.6977 21.6033 16.0472 20.9528C15.3967 20.3023 15.0312 19.42 15.0312 18.5Z" fill="#2F80ED" />
                </g>
                <defs>
                    <clipPath id="clip0_2595_1187">
                        <rect width="37" height="37" fill="white" />
                    </clipPath>
                </defs>
            </svg> {t("common:leave_request_label")}</h2>
            <form className={`dashboard-form ${classes.form}`} onSubmit={onSubmit}>
                <h3 className="dashboard-title" style={{ textAlign: "center" }}>{t("common:request_integration_label")}</h3>
                <button disabled={disabled} className={`btn ${classes.btn}`}>{t("common:send_label")}</button>
            </form>
        </div>
    )
}

function mapState(state) {
    const {
        userSelectedData,
    } = state;
    return {
        userSelectedData,
    };
}

export default connect(mapState)(IntegrationRequest);